<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div>
  <div class="cssLayoutRowStartCenter bottom-button" style="overflow: hidden;">
    <div class="icon">
      <img width="50" alt="alert" src="assets/img/SP_Icon_Alert.png" />
    </div>
    <div>
      <div>
        <h2>{{ displayTitle }}</h2>
      </div>
      <div class="messagebody">
        {{ displayMessage }}
      </div>
    </div>
    <div>
      <button (click)="close()" mat-icon-button aria-label="Close" alt class="no-outline">
        <mat-icon
          title="Close"
          class="icon-24px"
          fontIcon="mdi-close"
        ></mat-icon>
      </button>
    </div>
  </div>
</div>
